import React, { useEffect, useState } from 'react';
import { Gateway, Verdieping } from 'src/common/types';

import 'src/pages/Instellingen/components/VerdiepingenComponent.css';

type Props = {
  verdiepingen: Verdieping[];
  selectedVerdiepingen: Verdieping[];
  index?: number;
  updateVerdiepingen: (key: keyof Gateway, newVerdiepingen: Verdieping[], index: number) => void;
};

export const VerdiepingenComponent = ({ verdiepingen, selectedVerdiepingen, index = -1, updateVerdiepingen }: Props) => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [newVerdiepingen, setNewVerdiepingen] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    setNewVerdiepingen(
      selectedVerdiepingen.reduce(
        (acc, verdieping) => {
          acc[verdieping.id] = true;
          return acc;
        },
        {} as { [key: string]: boolean }
      )
    );
  }, [verdiepingen, selectedVerdiepingen, popupVisible]);

  const handleCheckboxChange = (verdieping: Verdieping, checked: boolean) => {
    setNewVerdiepingen({ ...newVerdiepingen, [verdieping.id]: checked });
  };

  const handleUpdateVerdiepingen = () => {
    updateVerdiepingen(
      'verdiepingen',
      verdiepingen.filter(verdieping => !!newVerdiepingen[verdieping.id]),
      index
    );
    setPopupVisible(false);
  };

  const selectedVerdiepingenToString = (): string => {
    return selectedVerdiepingen.map(v => v.code).join(', ');
  };

  const getVerdiepingText = (): string => {
    const strVerdiepingen = selectedVerdiepingenToString();
    if (strVerdiepingen.length > 10) {
      return strVerdiepingen.substring(0, 10) + ' ...';
    }
    return selectedVerdiepingen.length == 0 ? 'Selecteer' : strVerdiepingen;
  };

  if (!popupVisible)
    return (
      <span className="verdieping-span" title={selectedVerdiepingenToString()} onClick={() => setPopupVisible(true)}>
        {getVerdiepingText()}
      </span>
    );

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Select Verdiepingen</h2>
        <ul>
          {verdiepingen.map(verdieping => (
            <li key={verdieping.id}>
              <label className="verdieping-label" htmlFor={verdieping.id}>
                {verdieping.name}
              </label>
              <div>
                <input
                  id={verdieping.id}
                  type="checkbox"
                  onChange={e => handleCheckboxChange(verdieping, e.target.checked)}
                  checked={!!newVerdiepingen[verdieping.id]}
                />
              </div>
            </li>
          ))}
        </ul>
        <div>
          <button onClick={() => setPopupVisible(false)}>Cancel</button>
          <button onClick={handleUpdateVerdiepingen}>Ok</button>
        </div>
      </div>
    </div>
  );
};
